import { render, staticRenderFns } from "./DescriptionBookCreateEdit.vue?vue&type=template&id=35051b59&scoped=true&"
import script from "./DescriptionBookCreateEdit.vue?vue&type=script&lang=js&"
export * from "./DescriptionBookCreateEdit.vue?vue&type=script&lang=js&"
import style0 from "./DescriptionBookCreateEdit.vue?vue&type=style&index=0&lang=css&"
import style1 from "./DescriptionBookCreateEdit.vue?vue&type=style&index=1&id=35051b59&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35051b59",
  null
  
)

export default component.exports